import EventDetailsBottom from './EventDetailsBottom';

export default EventDetailsBottom;
